/**
 * Wire schema for `POST /api/v4/actions/:slug/execute`'s response body, as the
 * web reads it. The route answers with one of two shapes
 * (`src/api/v4/action-routes.ts`):
 *  - a 200/422 `ExecutionResult` (`execution-result.ts`);
 *  - a route-level 4xx/5xx `problem()` body, which this schema does not read:
 *    its sentence is `ApiProblemError.userMessage`.
 *
 * Every field is optional here so one schema reads an `ExecutionResult` off a
 * success body or an `ApiProblemError.body`. `error` is the older route-level
 * `{ error: { code, message } }` envelope, still read if a body carries it.
 */

import { z } from 'zod';
import { ExecutionResultSchema } from './execution-result';

export const ExecuteActionResponseSchema = ExecutionResultSchema.partial().extend({
  error: z.object({ code: z.string().optional(), message: z.string().optional() }).optional(),
});
export type ExecuteActionResponse = z.infer<typeof ExecuteActionResponseSchema>;
